import { FilterItemConfig } from '../types/filter-config';
import { FilterState } from '../filter.state';
import { Filter } from '../types/filter';

export interface FilterOptions<T extends object> {
  factory: (ref: FilterStateFactoryRef<T>) => void;
  initialValue?: Filter<T>;
  /** stable identifier of this filter state inside a filter template */
  key?: string;
}

export class FilterStateFactoryRef<T extends object> {
  items: FilterItemConfig<T>[] = []

  addItem(item: FilterItemConfig<T>) {
    this.items.push(item);
  }
}

export function filter<T extends object>(options: FilterOptions<T>): FilterState<T> {
  const filterRef = new FilterStateFactoryRef<T>();
  options.factory(filterRef);
  return new FilterState<T>({
    key: options.key,
    items: filterRef.items,
    initialValue: options.initialValue ?? null
  });
}
